// 앱 진입점 — Sentry instrument.ts를 최우선으로 import
import './instrument';
import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { confirmBundleReady, checkForUpdate } from './utils/liveUpdate';
import { initPushNotificationHandlers } from './utils/pushHandlers';

// ⚠️ 반드시 React 마운트보다 먼저, 최대한 일찍 호출해야 한다.
// 새 번들로 켜진 뒤 capacitor.config.ts의 readyTimeout 안에 ready()가 닿지 않으면
// 플러그인이 정상 번들도 실패로 간주해 롤백하고, autoBlockRolledBackBundles에 의해
// 그 번들을 영구 차단한다(= 해당 버전 OTA가 영영 적용 불가).
// App.tsx의 useEffect에서 부르던 것을 옮긴 것 — 저사양 기기에서는 React 트리 마운트까지
// 10초를 넘겨 실제로 롤백되는 것을 에뮬레이터 검증에서 확인했다.
confirmBundleReady();

const rootElement = document.getElementById('root') as HTMLElement;

const root = ReactDOM.createRoot(rootElement, {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),
  onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// 새 번들 확인은 급하지 않으므로 렌더 이후에 시작한다 (초기 구동을 늦추지 않도록)
checkForUpdate();

// 알림 탭 처리 리스너 등록 (네이티브에서만 동작, 중복 등록 방지됨)
initPushNotificationHandlers();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('[SW] 등록 완료:', registration.scope);
      })
      .catch((err) => {
        console.warn('[SW] 등록 실패:', err);
      });
  });
}

reportWebVitals();
